import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SupportOurChannelService } from './support-our-channel.service';

@Component({
    selector: 'app-support-our-channel',
    templateUrl: './support-our-channel.component.html',
    styleUrls: ['./support-our-channel.component.scss']
})
export class SupportOurChannelComponent implements OnInit {

	public data: any;

    constructor(
		private content: SupportOurChannelService,
        public router: Router
    ) {
    }

    ngOnInit(): void {}

}